import React from "react";
import { Box, Chip } from "@mui/material";
import i18next from "i18next";
import EAIcon from "./EAIcon";

const ContactInscriptionStatusChip = ({ registrationStatus }) => {
    return (
        <Box display="flex">
            {registrationStatus === "REGISTERED" && (
                    <Chip
                        icon={<EAIcon icon="registered_green" />}
                        size="small"
                        label={i18next.t(`contactsTable.status.${registrationStatus}.label`)}
                        color="primary"
                        variant="outlined"
                        sx={{
                          padding: "4px 8px",
                          backgroundColor : "#D7F4DC",
                          color : "#54CC54",
                          fontWeight: 600,
                          fontSize: "10px",
                          borderRadius: "6px",
                          border: "none",
                        }}
                    />
            )}
            {(registrationStatus === "INVITED") && (
                    <Chip
                        className="infoChip"
                        icon={<EAIcon icon="registered_blue" />}
                        size="small"
                        label={i18next.t(`contactsTable.status.${registrationStatus}.label`)}
                        variant="outlined"
                        sx={{
                            padding: "4px 8px",
                            backgroundColor : "#CCDEFF",
                            color : "#0047CC",
                            fontWeight: 600,
                            fontSize: "10px",
                            borderRadius: "6px",
                            border: "none",
                        }}
                    />
            )}
            {(registrationStatus === "EXPIRED_INVITATION") && (
                    <Chip
                        className="greyChip"
                        icon={<EAIcon icon="help-rounded" />}
                        size="small"
                        label={i18next.t(`contactsTable.status.${registrationStatus}.label`)}
                        variant="outlined"
                        sx={{
                            padding: "4px 8px",
                            backgroundColor : "#F2F3F7",
                            color : "#656575",
                            fontWeight: 600,
                            fontSize: "10px",
                            borderRadius: "6px",
                            border: "none",
                        }}
                    />
            )}
            {(registrationStatus === "DECLINED") && (
                    <Chip
                        className="greyChip"
                        icon={<EAIcon icon="help-rounded" />}
                        size="small"
                        label={i18next.t(`contactsTable.status.${registrationStatus}.label`)}
                        variant="outlined"
                        sx={{
                            padding: "4px 8px",
                            backgroundColor : "#E8E8E8",
                            color : "#7A7A7A",
                            fontWeight: 600,
                            fontSize: "10px",
                            borderRadius: "6px",
                            border: "none",
                        }}
                    />
            )}
        </Box>
    )
}
export default ContactInscriptionStatusChip;
